import { Form } from 'antd';
import { useContext, useMemo, useState } from 'react';

import { BrandSelect } from 'app/components/commons/Experience/BasicInfo/BrandSelect/BrandSelect';
import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useGetBrands } from 'app/hooks/data/useBrands';
import { useDebounce } from 'app/utils/hooks/useDebounce';

export const Brand = () => {
  const form = Form.useFormInstance();
  const formValues = Form.useWatch(['brand'], form);
  const { isEditMode } = useContext(ViewEditModeContext);
  const [brandSearch, setBrandSearch] = useState('');
  const debouncedBrandSearch = useDebounce(brandSearch);

  const makeBrandPayload = useMemo(
    () => ({
      limit: 50,
      search: debouncedBrandSearch ?? '',
    }),
    [debouncedBrandSearch]
  );
  const { data: brands } = useGetBrands(makeBrandPayload);

  return (
    <FormLineLayout
      label="Brand"
      description="If applicable, it will be highlighted in the activity title"
    >
      <Form.Item name="brand">
        {isEditMode ? (
          <BrandSelect
            experiencesBrands={brands ?? []}
            setSearch={setBrandSearch}
          />
        ) : (
          <span className="view-data">{formValues || 'ø empty'}</span>
        )}
      </Form.Item>
    </FormLineLayout>
  );
};
